export const SUPPORTED_LANGUAGES = [
  "en",
  "hi",
  "es",
  "ja",
  "de",
  "fr",
  "hr",
  "pl",
  "ro",
  "sk",
  "sv",
  "uk"
] as const;

export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: AppLanguage = "en";

export const LANGUAGE_STORAGE_KEY = "assessment-candidate-language";

export const LANGUAGE_LABELS: Record<AppLanguage, string> = {
  en: "English",
  hi: "Hindi",
  es: "Spanish",
  ja: "Japanese",
  de: "German",
  fr: "French",
  hr: "Croatian",
  pl: "Polish",
  ro: "Romanian",
  sk: "Slovak",
  sv: "Swedish",
  uk: "Ukrainian"
};

export const resolveSupportedLanguage = (
  rawLanguage?: string | null
): AppLanguage | null => {
  if (!rawLanguage) return null;

  const normalizedValue = rawLanguage
    .trim()
    .toLowerCase()
    .replace("_", "-")
    .split("-")[0];

  if (SUPPORTED_LANGUAGES.includes(normalizedValue as AppLanguage)) {
    return normalizedValue as AppLanguage;
  }

  const matchedByLabel = (Object.entries(LANGUAGE_LABELS).find(
    ([, label]) => label.toLowerCase() === rawLanguage.trim().toLowerCase()
  )?.[0] || null) as AppLanguage | null;

  return matchedByLabel;
};
